"use client";

import { c as _c } from "react/compiler-runtime";
import type { SyntheticEvent } from "react";
import { ensureTwitterLink } from "@/components/drops/view/part/dropPartMarkdown/twitter";
import SmartLinkPreview from "@/components/waves/SmartLinkPreview";
import TwitterPreviewCard from "@/components/waves/TwitterPreviewCard";
import type { LinkPreviewVariant } from "@/components/waves/LinkPreviewContext";
const getFallbackLabel = (href: string): string => {
  try {
    const url = new URL(href);
    const host = url.hostname.replace(/^www\./i, "");
    return host || href;
  } catch {
    return href;
  }
};
const getTwitterPayload = (href: string) => {
  try {
    return ensureTwitterLink(href);
  } catch {
    return null;
  }
};
const stopPropagation = (event: SyntheticEvent) => {
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
};
export default function BoostedDropLinkPreview(t0) {
  const $ = _c(11);
  const {
    href,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "home" : t1;
  let t2;
  if ($[0] !== href) {
    t2 = getTwitterPayload(href);
    $[0] = href;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const twitterPayload = t2;
  if (twitterPayload) {
    const {
      tweetId,
      href: normalizedHref
    } = twitterPayload;
    let t3;
    if ($[2] !== normalizedHref || $[3] !== tweetId) {
      t3 = <div className="tw-h-full tw-w-full tw-min-w-0 tw-max-w-full" onClick={stopPropagation} onMouseDown={stopPropagation} onPointerDown={stopPropagation} onTouchStart={stopPropagation}><TwitterPreviewCard href={normalizedHref} tweetId={tweetId} /></div>;
      $[2] = normalizedHref;
      $[3] = tweetId;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== href) {
    t3 = () => <a href={href} target="_blank" rel="noopener noreferrer nofollow" onClick={_temp} className="tw-[overflow-wrap:anywhere] tw-break-words tw-text-sm tw-font-semibold tw-text-iron-100 tw-no-underline tw-transition tw-duration-200 hover:tw-text-white">{getFallbackLabel(href)}</a>;
    $[5] = href;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== href || $[8] !== t3 || $[9] !== variant) {
    t4 = <div className="tw-h-full tw-w-full tw-min-w-0 tw-max-w-full" onClick={stopPropagation} onMouseDown={stopPropagation} onPointerDown={stopPropagation} onTouchStart={stopPropagation}><SmartLinkPreview href={href} variant={variant} renderFallback={t3} /></div>;
    $[7] = href;
    $[8] = t3;
    $[9] = variant;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(e) {
  return e.stopPropagation();
}